(function () {
    'use strict';

    angular.module('GorillaBoy.services')
    .factory('DocumentStateService', [
        DocumentStateService
    ]);

    function DocumentStateService () {
        var docStateService = {};

        docStateService.resetDocumentState = function() {
            docStateService.contentType = null;
            docStateService.documentErrorCode = 0;
            docStateService.selectionPage = 0;
            docStateService.documentVersions = [];
            docStateService.timer = null; // promise used to grab underlays for the active version
            docStateService.activeVersionId = "";
            docStateService.activeVersionIndex = 1;
            docStateService.activeVersion = null;
            docStateService.documentVersionDownloadUrl = "";
            docStateService.pdfUnderlayShown = false;
            docStateService.initialPageNumForNewVersion = 1;
            docStateService.versionChanged = false;
            docStateService.currentPage = null;
            docStateService.previousPage = null;
            docStateService.pageChanged = false;

            // initialize number of pages in the document.
            docStateService.numberOfPages = 0;

            //Related to document rendering
            docStateService.renderedPagesIndex = [];

            //Related to permissions
            docStateService.locationType = null; // OWN_TYPE, SHARED_TYPE, RECYCLE_TYPE
            docStateService.userRights = null;

            //Related to permissions V2
            docStateService.currentUserRoles = null;

            // --- BEGIN PDF ---
            // NOTE = Some PDF stuff will probably go into its own file.
            // Related to loading pdf and text (annotation index)
            docStateService.pdfReady = false;


            // --- END PDF ---

            // --- BEGIN FEEDBACK INPUT ---
            // Note = will go into a new directive.
            // Related to status of creating feedback
            docStateService.isCreatingFeedback = false;
            docStateService.feedbackInputOverallShown = false;
            docStateService.feedbackInputPlaceholder = "";
            docStateService.feedbackInputMargin = 0;
            docStateService.feedbackNotifyContributors = true;

            // --- START ARROWS ---
            // Note = will go into a new "drawArrows" directive.
            // Related to drafting a comment
            docStateService.doNotDrawLines = false;
            docStateService.doNotScrollComments = false;
            docStateService.doNotAutoScrollComments = false;
            // --- END ARROWS ---

            // --- START FEEDBACK ---
            docStateService.feedback = {
                // Feedback is organized by indexing =
                // 1) (users) -> [feedback annotation objects]
                // 2) (version id) -> [annotation objects]
                // 3) (selected feedback)
                users: {},
                selectedFeedback: null
            };
            docStateService.hasFilter = false;
            docStateService.selectionLayerCache = {};
            docStateService.feedbackMetadata = {};
            docStateService.currentlyRendering = 0;
            docStateService.feedbackIdToDocumentVersionIdMap = {};
            docStateService.usersToAnnotationsCount = 1; // Used for assigning colors to users. Start at 1
            docStateService.feedbackFilterDescription = '';
            docStateService.showCompressedFeedbackFilter = false;

            //Used to store the strings of feedback version element.
            //These will be cleared when DocumentController is activated.
            docStateService.feedbackContainerByVersions = {};
            docStateService.generatedFeedbackVersionHTML = '';  //Used for storing the html of feedback version
            // -- END FEEDBACK ---
        };

        docStateService.resetDocumentState();

        return docStateService;
    }

}());
